module.exports = "<div id=\"spinner\">\r\n    <i [hidden]=\"!loading\" class=\"fa fa-cog fa-spin\"></i>\r\n</div>"